export enum OrgType {
  Region = 'Region',
  ServicePartner = 'Service Partner'
}

export class Organization {
  // TODO: Add Implementation
  public id: string = ''
}
